
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import en from 'apexcharts/dist/locales/en.json';
import ja from 'apexcharts/dist/locales/ja.json';
// import resources from '@/services/resources.js'
import { getLocaleMehod, getLocaleMethodKpi } from '@/api/locale';
import store from '@/store/';
import ProfileSurvey from '@/components/modals/SurveyModel.vue';
import DashboardMemosRail from '@/components/Memo/DashboardMemosRail.vue';
import AddEditMemoModal from '@/components/Memo/AddEditMemoModal.vue';
import Stores from '@/services/stores';
import moment from 'moment';
export default {
  components: { ProfileSurvey, DashboardMemosRail, AddEditMemoModal },
  data() {
    if (localStorage.getItem('dashboardMemosRailOpen') === null) {
      localStorage.setItem('dashboardMemosRailOpen', 'false');
    }
    const railState = localStorage.getItem('dashboardMemosRailOpen');
    const railType = localStorage.getItem('dashboardRailType') || 'memos';

    return {
      forcedAPIVersion: 1,
      canShowSurvey: false,
      isRailOpen: railState === 'true',
      activeMemoCategory: 'all',
      activeRailType: railType,
      memosLoading: false,
      memosLoadMoreLoading: false,
      memoItems: [],
      memoPageNumber: 0,
      memoPageSize: 10,
      memoHasMore: true,
      pendingRailOpen: false,
      isFlowChatOpen: false,
      flowChatPoller: null,
      flowAiBootstrapTimer: null,
      wasFlowChatOpen: false,
      memoModalOpen: false,
      memoModalMode: 'add',
      memoEditingItem: null,
      memoDefaultDate: moment().format('YYYY-MM-DD'),
      memoDefaultHour: '12:00'
    };
  },
  computed: {
    isHomeRoute() {
      return this.$route?.name === 'home' || this.$route?.path === '/';
    },
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState',
      'getCustom445DateRange'
    ]),
    ...mapGetters('user', ['getLocale', 'isAuthenticated', 'getToken']),
    memoRailCategories() {
      const t = this.$store.state.user.translate;
      const tagOptions = this.memoTagOptions;

      return [
        { label: t.all || 'All', value: 'all' },
        ...tagOptions
      ];
    },
    memoTagOptions() {
      const t = this.$store.state.user.translate || {};
      const options = [];

      for (let i = 1; i <= 10; i += 1) {
        const key = `memo_tag_option${i}`;
        const label = t[key];

        if (label) {
          options.push({ label, value: key });
        }
      }

      return options;
    },
    filteredMemoItems() {
      if (this.activeMemoCategory === 'all') {
        return this.memoItems;
      }
      return this.memoItems.filter(
        memo => memo.category === this.activeMemoCategory
      );
    },
    currentUserId() {
      return this.$store.state?.user?.profile?._id || '';
    },
    isMemoAdmin() {
      return !!this.$store.state?.user?.role?.isAdmin;
    }
  },
  watch: {
    $route() {
      this.syncRailState();
      this.ensureDefaultFlowAiOpen();
    }
  },
  async created() {
    window.aiBtnMethod = v => {
      window.renderAi = v;
    };
    window.displayChat = this.displayChat;
    this.displayChat();
    this.getPrompts();
    this.kpiPrompts();
    const version = '3.49.94';
    localStorage.setItem('App_Version', version);

    console.log('App_Version: ', version);

    let { profile } = store.state['user'];
    Vue.prototype?.$mixpanel?.track('webapp_version', {
      version,
      email: profile?.email
    });

    let notify = this.$q.notify;
    this.$q.notify = arg => {
      console.error(arg);
      if (arg.color == 'red') {
        delete arg.color;
        arg.type = 'negative';
        arg.position = 'top';
      } else if (arg.color == 'green') {
        delete arg.color;
        arg.type = 'positive';
        arg.position = 'top';
      }
      let { profile } = store.state['user'];
      if (arg.type === 'negative') {
        Vue.prototype?.$mixpanel?.track('error', {
          referrer: document.referrer,
          version,
          url: window.location.href,
          arg,
          email: profile?.email
        });
      }
      arg.classes = ['full-width notification_top notification_' + arg.type];
      arg.actions = [
        {
          color: 'black',
          icon: 'close',
          'aria-label': 'Dismiss'
        }
      ];
      if (arg.message && arg.message != 'undefined') {
        notify(arg);
      }
    };

    window.showNotification = (type, message) => {
      this.$q.notify({
        message: message || 'A simple Message',
        type: type,
        position: 'top',
        timeout: 30000,
        classes: ['full-width notification_top notification_' + type],
        actions: [
          {
            color: 'black',
            icon: 'close',
            'aria-label': 'Dismiss'
          }
        ]
      });
    };
    let s = 0;
    const startObserving = (domNode, classToLookFor) => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(function(mutation) {
          const elementAdded = Array.from(mutation.addedNodes).some(element => {
            if (element.classList) {
              return element.classList.contains(classToLookFor);
            } else {
              return false;
            }
          });
          const focusHighlighted = () => {
            const allH = document.querySelectorAll(
              '.calender-card .vc-weeks .vc-highlight.vc-bg-blue-600'
            );
            let found = -1;
            for (let i = 0; i < allH.length; i++) {
              if (allH[i].offsetParent && !allH[i].closest('.vc-opacity-0')) {
                found = i;
                const thisEle = allH[i];
                thisEle?.closest('.vc-pane').scrollIntoView(true);
                break;
              }
            }
            if (found == -1) {
              triggerHighlight();
            }
          };
          const triggerHighlight = () => {
            clearTimeout(s);
            s = setTimeout(focusHighlighted, 400);
          };
          if (elementAdded) {
            triggerHighlight();
          }
        });
      });

      observer.observe(domNode, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
      });

      return observer;
    };

    startObserving(document.body, 'q-position-engine');
    getLocaleMehod();
    // getLocaleMethodKpi();
  },
  async mounted() {
    localStorage.setItem('dashboardMemosRailOpen', 'false');
    window.addEventListener('flow:rail:open', this.handleRailOpenRequest);
    window.addEventListener('flow:rail:close', this.handleRailCloseRequest);
    this.syncRailState();
    this.wasFlowChatOpen = this.getFlowChatOpenState();
    if (this.isHomeRoute) {
      this.fetchMemos({ reset: true });
    }

    this.initFlowChatObserver();
    this.initFlowChatPoller();
    this.ensureDefaultFlowAiOpen();
    
    setTimeout(() => {
      window['profile'] = store.state.user.profile;
      window['refreshData'] = async () => {
        const params = this.getParamsForOverview();
        return await this.fetchOverview(params);
      };
    }, 1000);
    let surveyEmailAllowed = [
      'testinguser@flow-solutions.com',
      'shuhei@flow-insight.com'
    ];

    console.log(
      this.canShowSurvey,
      this.isAuthenticated,
      store.state.user.profile.email
    );
    this.canShowSurvey =
      surveyEmailAllowed.indexOf(store.state.user.profile.email) > -1;
    // this.canShowSurvey = true; //store.state.user.profile.email == "shuhei@flow-insight.com"
    let cVer = Number(localStorage.getItem('forcedAPIVersion'));
    if (cVer !== this.forcedAPIVersion) {
      await this.fetchKpiPreferences();
      localStorage.setItem('forcedAPIVersion', this.forcedAPIVersion);
    }

    // this.getTranslations();

    const wa = document.createElement('script');
    window.__lo_site_id = 132500;
    window.Apex.chart = {
      locales: [en, ja],
      defaultLocale: this.getLocale
    };
    wa.type = 'text/javascript';
    wa.async = true;
    wa.src = 'https://d10lpsik1i8c69.cloudfront.net/w.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wa, s);
    document.head.appendChild(wa);
  },
  beforeDestroy() {
    if (this.flowChatPoller) {
      clearInterval(this.flowChatPoller);
      this.flowChatPoller = null;
    }
    if (this.flowAiBootstrapTimer) {
      clearInterval(this.flowAiBootstrapTimer);
      this.flowAiBootstrapTimer = null;
    }
  },
  methods: {
    ...mapActions('target', ['getPrompts', 'kpiPrompts']),
    ...mapActions('user', ['fetchKpiPreferences']),
    ...mapActions('overview', ['fetchOverview']),
    handleRailOpenRequest(event) {
      if (this.isRailOpen) {
        this.handleRailCloseRequest();
        return;
      }
      this.forceCloseFlowChat();
      this.isRailOpen = true;
      localStorage.setItem('dashboardMemosRailOpen', 'true');
      localStorage.setItem('dashboardRailType', 'memos');
      this.updateMemosRailBodyClass();
      this.fetchMemos({ reset: true });
    },
    forceOpenMemosRail() {
      this.isRailOpen = this.isHomeRoute;
      localStorage.setItem('dashboardMemosRailOpen', 'true');
      localStorage.setItem('dashboardRailType', 'memos');
    },
    handleRailCloseRequest() {
      this.isRailOpen = false;
      this.pendingRailOpen = false;
      localStorage.setItem('dashboardMemosRailOpen', 'false');
      this.updateMemosRailBodyClass();
    },
    handleMemoCategoryChange(category) {
      this.activeMemoCategory = category;
    },
    syncRailState() {
      const railState = localStorage.getItem('dashboardMemosRailOpen');
      this.isRailOpen = railState === 'true';
      this.activeRailType = 'memos';
      this.updateMemosRailBodyClass();
      if (this.isRailOpen) {
        this.fetchMemos({ reset: true });
      }
    },
    updateMemosRailBodyClass() {
      if (typeof document === 'undefined') return;
      const shouldOpen = this.isRailOpen;
      document.body.classList.toggle('memos-rail-open', shouldOpen);
      this.updateChatOpenClass();
    },
    updateChatOpenClass() {
      if (typeof document === 'undefined') return;
      const shouldOpen = this.isRailOpen || this.getFlowChatOpenState();
      if (this.wasFlowChatOpen && !shouldOpen) {
        localStorage.setItem('flowAiDismissed', 'true');
      }
      this.wasFlowChatOpen = shouldOpen;
      document.body.classList.toggle('chat-open', shouldOpen);
    },
    ensureDefaultFlowAiOpen() {
      if (typeof window === 'undefined') return;
      if (this.isRailOpen) return;
      if (this.getFlowChatOpenState()) return;
      if (localStorage.getItem('flowAiDismissed') === 'true') return;
      if (this.flowAiBootstrapTimer) return;

      let attempts = 0;
      this.flowAiBootstrapTimer = setInterval(() => {
        attempts += 1;

        if (this.isRailOpen || this.getFlowChatOpenState()) {
          clearInterval(this.flowAiBootstrapTimer);
          this.flowAiBootstrapTimer = null;
          this.updateChatOpenClass();
          return;
        }

        if (typeof window.showChat === 'function') {
          try {
            window.showChat(true);
            this.updateChatOpenClass();
          } catch (e) {
            // keep retrying until the widget is fully ready
          }
        }

        if (attempts >= 20) {
          clearInterval(this.flowAiBootstrapTimer);
          this.flowAiBootstrapTimer = null;
        }
      }, 500);
    },
    getFlowChatOpenState() {
      if (typeof document === 'undefined') return false;
      const flowChatEl = document.getElementById('flow-chat');
      if (!flowChatEl || !flowChatEl.childNodes.length) return false;

      const isVisible = el => {
        if (!el || el.nodeType !== 1) return false;
        const style = window.getComputedStyle(el);
        if (
          style.display === 'none' ||
          style.visibility === 'hidden' ||
          style.opacity === '0'
        ) {
          return false;
        }
        const rect = el.getBoundingClientRect();
        return rect.width > 1 && rect.height > 1;
      };

      const elements = Array.from(flowChatEl.querySelectorAll('*'));
      if (!elements.length) return false;
      return elements.some(el => isVisible(el));
    },
    forceCloseFlowChat() {
      this.updateChatOpenClass();
      if (typeof window !== 'undefined' && typeof window.showChat === 'function') {
        try {
          window.showChat(false);
        } catch (e) {
          // no-op: some builds don't support closing via showChat
        }
      }
    },
    initFlowChatObserver() {
      if (typeof document === 'undefined') return;
      const flowChatEl = document.getElementById('flow-chat');
      if (!flowChatEl || this._flowChatObserver) return;

      const updateFlowChatState = () => {
        this.updateChatOpenClass();
      };
      updateFlowChatState();
      const observer = new MutationObserver(() => {
        updateFlowChatState();
      });
      observer.observe(flowChatEl, { childList: true, subtree: true });
      this._flowChatObserver = observer;
    },
    initFlowChatPoller() {
      if (this.flowChatPoller || typeof window === 'undefined') return;
      this.flowChatPoller = setInterval(() => {
        this.updateChatOpenClass();
      }, 500);
    },
    async fetchMemos({ reset = false, append = false } = {}) {
      try {
        const requestPage = reset
          ? 1
          : append
            ? this.memoPageNumber + 1
            : this.memoPageNumber || 1;

        if (append && !this.memoHasMore) return;

        if (reset) {
          this.memoPageNumber = 0;
          this.memoHasMore = true;
          this.memoItems = [];
        }

        this.memosLoading = !append;
        this.memosLoadMoreLoading = append;

        const res = await Stores.getStoreAnnotations({
          all: true,
          pageNumber: requestPage,
          perPage: this.memoPageSize
        });

        const rawResponse = res?.data?.response;
        const memos = Array.isArray(rawResponse)
          ? rawResponse
          : Array.isArray(rawResponse?.data)
            ? rawResponse.data
            : Array.isArray(rawResponse?.response)
              ? rawResponse.response
              : Array.isArray(rawResponse?.memos)
                ? rawResponse.memos
                : [];
        const totalCount =
          rawResponse?.totalCount ??
          rawResponse?.data?.totalCount ??
          rawResponse?.count ??
          res?.data?.totalCount ??
          res?.data?.count ??
          null;

        const storeMap = this.getStoresCodeNameMap();
        const tagLabelMap = this.memoTagOptions.reduce((acc, item) => {
          acc[item.value] = item.label;
          return acc;
        }, {});

        const mapped = memos.map(memo => {
          const date = moment(memo.startDate?.toString(), 'YYYYMMDD').format(
            'YYYY/MM/DD'
          );
          const hour = memo.startHour
            ? `${String(Math.floor(memo.startHour / 100)).padStart(2, '0')}:${String(
                memo.startHour % 100
              ).padStart(2, '0')}`
            : '12:00';
          const tags = memo.tags ? memo.tags.split(',') : [];
          const primaryTag = tags[0] || '';
          const storeLabel = storeMap[memo.storeId] || memo.storeId || '';
          const timestamp = memo?.cDate?.timeStamp || 0;
          const authorName = this.getMemoAuthorName(memo);
          const isCreator =
            !!memo?.userId &&
            !!this.currentUserId &&
            memo.userId === this.currentUserId;
          const canEdit = isCreator;
          const canDelete = isCreator || this.isMemoAdmin;

          return {
            id: memo._id,
            storeId: memo.storeId,
            title: storeLabel,
            meta: this.formatMemoMeta(authorName, date, hour),
            description: memo.text || '',
            category: primaryTag,
            categoryLabel: primaryTag
              ? tagLabelMap[primaryTag] ||
                this.$store.state.user.translate[primaryTag] ||
                primaryTag
              : '',
            tags,
            startDate: memo.startDate,
            endDate: memo.endDate,
            startHour: memo.startHour,
            timestamp,
            userId: memo.userId,
            authorName,
            canEdit,
            canDelete
          };
        });
        const merged = append ? [...this.memoItems, ...mapped] : mapped;
        const deduped = Array.from(
          new Map(merged.map(memo => [memo.id, memo])).values()
        );

        if (append) {
          this.memoItems = deduped;
        } else {
          this.memoItems = deduped
            .slice()
            .sort((a, b) => {
              if (b.timestamp !== a.timestamp) {
                return b.timestamp - a.timestamp;
              }
              if (b.startDate !== a.startDate) {
                return (b.startDate || 0) - (a.startDate || 0);
              }
              return (b.startHour || 0) - (a.startHour || 0);
            });
        }

        this.memoPageNumber = requestPage;
        if (typeof totalCount === 'number') {
          this.memoHasMore = this.memoItems.length < totalCount;
        } else {
          this.memoHasMore = mapped.length >= this.memoPageSize;
        }
      } catch (e) {
        console.error('Failed to fetch memos', e);
      } finally {
        this.memosLoading = false;
        this.memosLoadMoreLoading = false;
      }
    },
    loadMoreMemos() {
      this.fetchMemos({ append: true });
    },
    getStoresCodeNameMap() {
      const list = store.getters['user/getStoresCodeNameList'] || [];
      return list.reduce((acc, item) => {
        acc[item.id] = `${item.storeCode} - ${item.name}`;
        return acc;
      }, {});
    },
    getMemoAuthorName(memo) {
      const profile = this.$store.state?.user?.profile || {};
      if (memo?.userName) return memo.userName;
      if (memo?.username) return memo.username;
      if (memo?.fullName) return memo.fullName;
      if (memo?.userId && profile?._id && memo.userId === profile._id) {
        return profile.fullName || profile.email || 'User';
      }
      return 'User';
    },
    canCurrentUserDeleteMemo(item) {
      const currentUserId = this.$store.state?.user?.profile?._id || '';
      const isCreator =
        !!item?.userId && !!currentUserId && item.userId === currentUserId;

      return isCreator || this.isMemoAdmin;
    },
    formatMemoMeta(authorName, date, hour) {
      const name = authorName || 'User';
      if (!date) return name;

      const locale = (this.getLocale || 'en').toLowerCase();
      if (!hour) {
        return `${name}, ${date}`;
      }

      return locale.includes('ja')
        ? `${name}, ${date} ${hour}`
        : `${name}, ${date} at ${hour}`;
    },
    openAddMemo() {
      this.memoModalMode = 'add';
      this.memoEditingItem = null;
      this.memoDefaultDate = moment().format('YYYY-MM-DD');
      this.memoDefaultHour = '12:00';
      this.memoModalOpen = true;
    },
    openEditMemo(item) {
      if (!item || !item.canEdit) return;
      this.memoModalMode = 'edit';
      this.memoEditingItem = {
        id: item.id,
        store: item.storeId,
        startDate: item.startDate,
        endDate: item.endDate,
        time: item.startHour
          ? `${String(Math.floor(item.startHour / 100)).padStart(2, '0')}:${String(
              item.startHour % 100
            ).padStart(2, '0')}`
          : '12:00',
        description: item.description || '',
        tags: item.tags || []
      };
      this.memoModalOpen = true;
    },
    confirmDeleteMemo(item) {
      if (!this.canCurrentUserDeleteMemo(item)) return;
      this.$q
        .dialog({
          title: this.$store.state.user.translate.delete_memo || 'Delete Memo',
          message:
            this.$store.state.user.translate.are_you_sure_you_want_to_delete ||
            'Are you sure you want to delete this memo?',
          cancel: true,
          persistent: true
        })
        .onOk(() => {
          this.deleteMemo(item);
        });
    },
    async deleteMemo(item) {
      try {
        await Stores.deleteStoreAnnotations({
          id: item.id,
          storeId: item.storeId
        });
        this.memoItems = this.memoItems.filter(memo => memo.id !== item.id);
        await this.fetchMemos({ reset: true });
        this.$q.notify({
          type: 'positive',
          message: this.$store.state.user.translate.memo_deleted || 'Memo deleted'
        });
      } catch (error) {
        console.error('Delete memo failed', error);
        this.$q.notify({
          type: 'negative',
          message:
            this.$store.state.user.translate.failed_to_delete_memo ||
            'Failed to delete memo'
        });
      }
    },
    async handleMemoSaved() {
      await this.fetchMemos({ reset: true });
    },
    displayChat() {
      const usrChat = localStorage.getItem('usernameChat');
      if (!usrChat) return;

      const tokenChat = this.getToken;
      const lang = this.getLocale;
      const isprod = localStorage.getItem('chatIsProd');

      const initChat = () => {
        const obj = {
          token: tokenChat,
          lang,
          isSandbox: isprod,
          addBotCallback() {
            window.open('/Explore', '_self');
          }
        };
        window.flowLoadChat('flow-chat', obj);
      };

      // Wait for flowLoadChat to exist
      const check = setInterval(() => {
        if (typeof window.flowLoadChat === 'function') {
          clearInterval(check);
          initChat();
        }
      }, 300);
    },

    getParamsForOverview() {
      const stC = this.getStoreCodesList;
      if (!stC) return null;
      return {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        compareStartDate: this.getStartingCompared,
        compareEndDate: this.getEndingCompared,
        storeCodes: stC,
        daysOfWeek: this.getDaysOfWeekList,
        useCustomCalender: this.getCustomCalenderState,
        groupByMetricKey: true,
        comparisonYKPIMetricKey: this.kpiLabelValue?.[0]?.value
      };
    }
    //   allAppWeather(){
    //   const moment = require('moment');
    //   const startDate = moment('2023-04-04', 'YYYY-MM-DD');
    //   const endDate = moment('2023-04-04', 'YYYY-MM-DD');
    //   const cityName = 'つくば市';
    //   weather(startDate, endDate, cityName)
    //   .then((data) => {
    //       console.log(data, '=-->'); // Object containing average and most common values
    //   })
    //   .catch((err) => {
    //       console.error(`Error: ${err}`);
    //   });
    // },
    // async getTranslations() {
    //   var translation = await resources.setLanguage(this.$store.state.user.locale);
    //   this.$store.commit("store/setTranslation", translation);
    // }
  }
}; // export default
